import { DeepPartial, ScrollConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SCROLL: DeepPartial<ScrollConfig> = {
  scrollPanelSelector: '.ebx-empathy-x__body',
  scrollOffsetInPx: 50
};

export const DESKTOP_SCROLL: DeepPartial<ScrollConfig> = {
  scrollOffsetInPx: 0
};
